import { useI18n } from '@muse/i18n'

import { createLazyComponent } from '@muse-web/router'

import { AudioAiMasteringSection } from '../components/audio-ai-mastering-section/AudioAiMasteringSection'

const loadContent = () =>
    import(/* webpackChunkName: 'audio-transcription' */ './AudioTranscriptionContentContainer')

const AudioTranscriptionFallback = () => {
    const { t } = useI18n()

    return <AudioAiMasteringSection heading={t('i18n.audioAiMasteringHeading')} />
}

export const AsyncAudioTranscriptionContentContainer = createLazyComponent(
    loadContent,
    'AudioTranscriptionContentContainer',
    { keepServerMarkup: true, fallback: AudioTranscriptionFallback },
)
